module.exports = __webpack_public_path__ + "static/media/logoiut.db4f5325.webp";